import React from "react";

import "../styles/button.scss";

const Button = ({
  children,
  onClick = (a?) => {},
  type = "primary",
  size = "L",
  className = "",
  ...rest
}) => {
  const types = {
    primary: "button-primary",
    secondary: "button-secondary",
  };

  const sizes = {
    L: "button-L",
    M: "button-M",
    S: "button-S",
  };

  // <span> (was <button>) — wszystkie nasze CTA mają w środku <Link>/<a>/<AnchorLink>
  // który zapewnia native click + navigation + keyboard. <button>...<a>...</button>
  // to INVALID HTML (interactive w interactive) + Lighthouse touch-target audit
  // łapał OBA (button + inner a) jako 2 targety overlapping by 1px = false-fail.
  // <span> nie jest interactive → tylko inner <Link>/<a> jest tap targetem → pass.
  // Wszystkie style z .button class zachowane (selectors targetują class, nie tag).
  return (
    <span
      onClick={onClick}
      className={`button ${className} ${types[type]} ${sizes[size]}`}
      {...rest}
    >
      {children}
    </span>
  );
};

export default Button;
